import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a0e33e12ab6ae0014c1d725_1780094852721/arcade_1779315681188/src/app/events/page.tsx");
